import parserService from './parserService';
import searchService from './searchService';
import statsService from './statsService';

export default angular.module('searchEngineFrontend.searchInterface.shared.services', [])
    .service('ParserService', parserService)
    .factory('SearchService', searchService)
    .factory('StatsService', statsService);



// WEBPACK FOOTER //
// ./src/search-interface/shared/services/index.js